import { createReducer, on } from '@ngrx/store';

import { UserAccountHomeDto } from '../core/dtos/dto';
import { clearMyAccount, loadMyAccount } from './my-account.actions';

export const initialState: UserAccountHomeDto = null;

export const myAccountReducer = createReducer(
  initialState,

  on(clearMyAccount, () => initialState),

  on(loadMyAccount, (state, { myAccount }) => myAccount)
);
